// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_fy","advertDetailContactItem__link":"c-n_fz"};